module.exports = "/_next/static/images/PersonalizeAcrossSitesAppsChannels@2x-5fa113266fce6688ab675f8e71232f0c.webp";